import React, { useState } from 'react'
import { Flex, Img } from '@chakra-ui/react'
import LogoIB from '../../../assets/images/Logotipo.svg'
import { themeChakra } from '@wow/themes'
import { backgroundHeader } from 'utils/functions/backgroungHeader'

const HeaderOffRoad = () => {
  
  const [bgImage] = useState(`url(${backgroundHeader()})`)

  return (
    <Flex
      data-testid='headerOffRoad'
      backgroundColor={themeChakra.colors.tertiary[700]}
      style={{ backgroundImage: bgImage }}
      height='64px'
      w= '100%'
      justifyContent='center'
    >
      <Img src={LogoIB} alt='' width='52.15px' />
    </Flex>
)}

export default HeaderOffRoad